import styled from 'styled-components';
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`;
export const Description = styled.p `
  margin: 0;
  line-height: 1.5;
  color: var(--text-secondary);
`;
export const StepsList = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`;
export const StepItem = styled.div `
  display: flex;
  gap: var(--space-300);
  align-items: baseline;
`;
export const StepNumber = styled.span `
  font-weight: 600;
  flex-shrink: 0;
`;
export const StepContent = styled.span `
  flex: 1;
`;
export const ButtonContainer = styled.div `
  padding-left: calc(var(--space-300) + 1.5ch);
  max-width: fit-content;
`;
export const UrlInputContainer = styled.div `
  display: flex;
  gap: var(--space-300);
  align-items: center;
  padding-left: calc(var(--space-300) + 1.5ch);
`;
export const InputWrapper = styled.div `
  flex: 1;
`;
